import styled from 'styled-components';
import DeleteIcon from 'js/components/core/Icons/DeleteIcon';

export default styled(DeleteIcon)`
  height: 1rem;
  width: 1rem;
  margin: 0 1rem;
`;
